import { ColumnSizingState, Table } from '@tanstack/react-table'
import { ReactNode } from 'react'
import DataTable, { RenderRowProps } from './DataTable'
import PaginationBar from './PaginationBar'
import TableToolbar from './TableToolbar'

interface DataTableLayoutProps<TData> {
    table: Table<TData>
    isLoading?: boolean
    totalItems?: number
    hasColumnSelection?: boolean
    hasPageSizeSelect?: boolean
    noResultMessage?: string
    theadClass?: string
    tableFooter?: ReactNode
    updateColumnSizing?: (sizing: ColumnSizingState) => void
    toolbarActions?: () => ReactNode
    renderRow?: (props: RenderRowProps<TData>) => ReactNode
}

const DataTableLayout = <TData,>(props: DataTableLayoutProps<TData>) => {
    const {
        table,
        isLoading,
        totalItems,
        hasColumnSelection,
        hasPageSizeSelect,
        noResultMessage,
        theadClass,
        tableFooter,
        updateColumnSizing,
        toolbarActions,
        renderRow,
    } = props

    return (
        <>
            <TableToolbar
                table={table}
                totalItems={totalItems}
                hasColumnSelection={hasColumnSelection}
                toolbarActions={toolbarActions}
            />
            <DataTable
                table={table}
                isLoading={isLoading}
                useSkeleton
                noResultMessage={noResultMessage}
                theadClass={theadClass}
                tableFooter={tableFooter}
                updateColumnSizing={updateColumnSizing}
                renderRow={renderRow}
            />
            <PaginationBar
                table={table}
                totalItems={totalItems}
                hasPageSizeSelect={hasPageSizeSelect}
            />
        </>
    )
}

export default DataTableLayout
